import "./Loader.css";

function Loader(props) {
  return (
    <div className="loader">
      <div className="spinner">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
